<template>
  <vs-popup
    classContent="popup-example"
    title=""
    :active.sync="sscAdminInfoPopup"
  >
    <template>
      <div class="vx-row ml-2 mr-2">
        <center>
          <img v-bind:src="info_admin.cover" width="80%" />
        </center>
      </div>

      <hr />

      <div class="vx-row mb-2 ml-2 mr-2">
        <h2>{{ info_admin.title }}</h2>
      </div>

      <hr />

      <div class="vx-row mb-5 ml-2 mr-2">
        <p v-html="info_admin.content"></p>
      </div>
    </template>
  </vs-popup>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      privilegeInfo: [
        '',
        'Super Administrator',
        'Administrator',
        'Admin Cabang',
        'General User',
        'Dispatcher',
        'Limited User'
      ],
      roleInfo: -1,
      tokenInfo: '',
      sscAdminInfoPopup: false,
      info_admin: []
    }
  },

  created() {
    this.roleInfo =
      localStorage.getItem('userInfo') !== null
        ? this.privilegeInfo.indexOf(
            JSON.parse(localStorage.getItem('userInfo')).privilege
          )
        : -1

    this.tokenInfo =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
  },

  computed: {
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },

  mounted() {
    if (this.roleInfo == 3) {
      this.getInfoAdmin()
    }
  },

  methods: {
    getInfoAdmin() {
      if (localStorage.getItem('infoSscAdmin') == 'true') {
        this.$http
          .get(`${this.$api.portal_host}/get_news_category_ssc`, {
            headers: {
              Authorization: `Bearer ${this.tokenInfo}`
            }
          })
          .then((res) => {
            if (res.data.total > 0) {
              this.info_admin = res.data.message.data
              this.sscAdminInfoPopup = true
            } else {
              this.info_admin = []
              this.sscAdminInfoPopup = false
            }

            localStorage.setItem('infoSscAdmin', false)
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      }
    }
  }
}
</script>
